<template>
  <div class="saas-signup-card">
    <span class="saas-signup-card__title">Start using Baserow today</span>

    <ul class="saas-signup-card__usps">
      <li class="saas-signup-card__usp">
        <i class="iconoir-check-circle"></i>Create databases and applications
      </li>
      <li class="saas-signup-card__usp">
        <i class="iconoir-check-circle"></i>Collaborate in real-time
      </li>
      <li class="saas-signup-card__usp">
        <i class="iconoir-check-circle"></i>
        Control access internally and externally
      </li>
    </ul>

    <Button tag="nuxt-link" :to="{ name: 'signup' }" full-width size="large"
      >Get Started. It's FREE!</Button
    >
  </div>
</template>

<script>
export default {
  name: 'SignupCard',
}
</script>
